import Vue from 'vue'

Vue.component('vue-card', () => import('./base-components/VCard.vue'))
Vue.component('vue-input', () => import('./base-components/VInput.vue'))
Vue.component('vue-chart', () => import('./base-components/VChart.vue'))
Vue.component('vue-state', () => import('./base-components/VState.vue'))
